module.exports = __webpack_public_path__ + "static/img/10.4e05dc49.jpg";